import { RawHomeData } from '@ubiety/fe-api';

import { Home } from '../types/home';
import { snakeToCamelCasePropertyNames } from '../utils';

export const processRawHomeData = (rawHomeData: RawHomeData): Home => {
  return snakeToCamelCasePropertyNames(rawHomeData) as Home;
};